module.exports = __webpack_public_path__ + "img/40_69_011_560.d9404db8.jpg";